import TabularDataTable from './TabularDataTable'
import _ from 'underscore'

function TabularDataWithEffectiveDatesTable() {}

TabularDataWithEffectiveDatesTable.prototype = _.create(TabularDataTable.prototype);

TabularDataWithEffectiveDatesTable.prototype.init = function( tHeadEl, changesCallback, validateCallback, currentTimeInUserTimeZone )
{
    TabularDataTable.prototype.init.call( this, tHeadEl, changesCallback, validateCallback );

    this.todayInUserTimeZone = currentTimeInUserTimeZone.parseJSONDate().truncateTime();

    return this;
};

TabularDataWithEffectiveDatesTable.prototype.getEffectiveRowIdx = function()
{
    var effectiveRowIdx = null;
    var effectiveDate = null;

    for( var i = 0; i < this.rows.length; i++ )
    {
        var row = this.rows[i];
        var cell = row.cells[0];

        if( !row.isMarkedToRemove() && !cell.isEmpty() && cell.isValid() && this.todayInUserTimeZone >= cell.getValue() && (effectiveDate == null || effectiveDate < cell.getValue()) )
        {
            effectiveRowIdx = i;
            effectiveDate = cell.getValue();
        }
    }

    return effectiveRowIdx;
};

TabularDataWithEffectiveDatesTable.prototype.updateEffectiveRow = function()
{
    var effectiveRowIdx = this.getEffectiveRowIdx();
    var oldEffectiveRowIdx = null;

    for( var i = 0; i < this.rows.length; i++ )
    {
        var row = this.rows[i];
        if( row.isEffective() )
            oldEffectiveRowIdx = i;
        row.setEffective( false );
    }

    if( effectiveRowIdx != null )
    {
        this.rows[effectiveRowIdx].setEffective( true );
        this.rows[effectiveRowIdx].updateRowClasses();
    }

    if( oldEffectiveRowIdx != null && oldEffectiveRowIdx != effectiveRowIdx )
        this.rows[oldEffectiveRowIdx].updateRowClasses();

    return effectiveRowIdx;
};

TabularDataWithEffectiveDatesTable.prototype.markRowsWithEqualEffectiveDatesAsInvalid = function()
{
    var rowsArray = this.getRowsWithEqualEffectiveDates();
    var hasInvalid = false;
    for( var i = 0; i < this.rows.length; i++ )
    {
        var cell = this.rows[i].cells[0];
        if( rowsArray[i] )
        {
            cell.setInvalid();
            hasInvalid = true;
        }
        else if( !cell.isEmpty() )
        {
            cell.setValid();
        }
        cell.updateUI();
    }
    return hasInvalid;
};

TabularDataWithEffectiveDatesTable.prototype.getRowsWithEqualEffectiveDates = function()
{
    var datesSet = {};
    var rowsWithEqualMarks = [false];

    for( var i = 0; i < this.rows.length; i++ )
    {
        if( this.rows[i].isMarkedToRemove() )
            continue;
        var date = this.rows[i].cells[0].getValue();
        if( date != null )
        {
            var dateStr = date.toJSON();
            if( datesSet.hasOwnProperty(dateStr) )
            {
                rowsWithEqualMarks[i] = true;
                rowsWithEqualMarks[datesSet[dateStr]] = true;
                continue;
            }
            datesSet[dateStr] = i;
        }
    }

    return rowsWithEqualMarks;
};

TabularDataWithEffectiveDatesTable.prototype.hasRowsWithEqualEffectiveDates = function()
{
    var rowsWithEqualEffectiveDates = this.getRowsWithEqualEffectiveDates();
    for( var i = 0; i < rowsWithEqualEffectiveDates.length; i++ )
        if( rowsWithEqualEffectiveDates[i] )
            return true;
    return false;
};

TabularDataWithEffectiveDatesTable.prototype.hasErrors = function()
{
    return TabularDataTable.prototype.hasErrors.call(this) || this.hasRowsWithEqualEffectiveDates();
};

TabularDataWithEffectiveDatesTable.prototype.validate = function()
{
    var valid = TabularDataTable.prototype.validate.call( this );
    var hasRowsWithEqualEffectiveDates = this.markRowsWithEqualEffectiveDatesAsInvalid();
    return valid && !hasRowsWithEqualEffectiveDates;
};

TabularDataWithEffectiveDatesTable.prototype.doToggleRemove = function( rowIdx )
{
    TabularDataTable.prototype.doToggleRemove.call(this, rowIdx);
    this.markRowsWithEqualEffectiveDatesAsInvalid();
    this.updateEffectiveRow();
};

TabularDataWithEffectiveDatesTable.prototype.removeRowPermanently = function( rowIdx )
{
    this.removeRow(rowIdx);
    this.markRowsWithEqualEffectiveDatesAsInvalid();
    this.updateEffectiveRow();
};

TabularDataWithEffectiveDatesTable.prototype.triggerUpdateEvent = function() {
//    abstract
}

TabularDataWithEffectiveDatesTable.prototype.addEmptyRow = function(  )
{
    TabularDataTable.prototype.addEmptyRow.call( this );
    this.updateEffectiveRow();
    this.onRowAmountChange();
};
TabularDataWithEffectiveDatesTable.prototype.buildDOM = function( containerEl )
{
    TabularDataTable.prototype.buildDOM.call(this, containerEl);
    this.updateEffectiveRow();
};

TabularDataWithEffectiveDatesTable.prototype.setOpenedExtJSSelector = function(openedExtJSSelector)
{
    this.openedExtJSSelector = openedExtJSSelector;
}
TabularDataWithEffectiveDatesTable.prototype.hideOpenedExtJSSelector = function()
{
    if (this.openedExtJSSelector) {
        this.openedExtJSSelector.hideMenuOnScrollOrResize();
    }
}

export default TabularDataWithEffectiveDatesTable



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/TabularDataWithEffectiveDatesTable.js